<template>
  <b-modal
    v-model="visible"
    size="lg"
    centered
    scrollable
    hide-header
    modal-class="migrate-modal"
    body-class="p-0"
    no-close-on-backdrop
    no-close-on-esc
  >
    <migrate-notice compact />

    <template #modal-footer>
      <div class="mg-actions">
        <b-form-checkbox v-model="hideToday">
          Không hiện lại hôm nay
        </b-form-checkbox>
        <b-button
          variant="flat-secondary"
          size="sm"
          @click="skip"
        >
          Bỏ qua, tiếp tục sử dụng
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { BModal, BButton, BFormCheckbox } from 'bootstrap-vue'
import MigrateNotice from './MigrateNotice.vue'

const STORAGE_KEY = 'migrate-notice-hidden-until'

export default {
  components: {
    BModal,
    BButton,
    BFormCheckbox,
    MigrateNotice,
  },
  data() {
    return {
      visible: false,
      hideToday: false,
    }
  },
  mounted() {
    // mặc định luôn hiện, trừ khi người dùng đã tick "không hiện lại hôm nay" trong ngày
    this.visible = this.readHiddenUntil() !== this.today()
  },
  methods: {
    today() {
      const d = new Date()
      const m = `${d.getMonth() + 1}`.padStart(2, '0')
      const day = `${d.getDate()}`.padStart(2, '0')
      return `${d.getFullYear()}-${m}-${day}`
    },
    readHiddenUntil() {
      try {
        return window.localStorage.getItem(STORAGE_KEY)
      } catch (e) {
        // localStorage bị chặn (private mode) -> coi như chưa từng ẩn
        return null
      }
    },
    skip() {
      if (this.hideToday) {
        try {
          window.localStorage.setItem(STORAGE_KEY, this.today())
        } catch (e) {
          // không ghi nhớ được thì lần sau vẫn hiện, chấp nhận được
        }
      }
      this.visible = false
    },
  },
}
</script>

<style lang="scss">
.migrate-modal {
  .modal-dialog {
    max-width: 760px;
  }

  .modal-content {
    overflow: hidden;
  }

  .modal-body {
    background: transparent;
  }

  .modal-footer {
    padding: 0.65rem 1rem;
  }

  .mg-actions {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    flex-wrap: wrap;
  }
}
</style>
